export const matchesOtherProductCategories = (row, field, matches) => {
  const otherCategories = row?.otherCategories || [];
  return otherCategories.some((cat) => {
    if (field === 'category' || field === 'displayCategory') return matches(cat.category?.name ?? cat.category);
    if (field === 'subcategory' || field === 'displaySubcategory') return matches(cat.subcategory?.name ?? cat.subcategory);
    return false;
  });
};
